/* FOYENA - apercu en direct des affiches (carte du ciel, affiche film, coffret duo).
   Reprend exactement la geometrie de skymap.py et filmposter.py (memes formules, meme catalogue). */
(function () {
  if (window.FY_PREVIEW) return;
  window.FY_PREVIEW = true;

  var MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  var THEMES = {
    nuit: { bg: "#0B1426", fg: "#F3E9D2", star: "#FFF8E7", line: "#C9B37E", grid: "#2A3A5C", ring: "#C9B37E" },
    creme: { bg: "#F4EEE3", fg: "#1D2433", star: "#1D2433", line: "#8A6F3A", grid: "#D9CFBE", ring: "#1D2433" },
    minuit: { bg: "#000000", fg: "#FFFFFF", star: "#FFFFFF", line: "#9AA4B2", grid: "#1E2530", ring: "#FFFFFF" }
  };
  var D2R = Math.PI / 180;
  var cfg = window.FY_CFG || {};
  function fieldsHTML(T, S, F) {
    var inp = function (id, key, label, help, attrs) {
      return '<div><label for="fy-' + id + '-' + S + '">' + label + '</label>' + (help ? '<small>' + help + '</small>' : '') +
        '<input id="fy-' + id + '-' + S + '" data-fy="' + key + '" form="' + F + '" ' + attrs + '></div>';
    };
    var h = '<div class="fy-hd"><p>Personnalisez votre affiche</p><span class="fy-note"><span class="fy-dot" aria-hidden="true"></span>L\'aperçu se met à jour en direct</span></div><div class="fy-inline fy-scene" aria-live="off"><div class="fy-wall"></div></div>';
    if (T === "naissance") h += inp("n", "names", "Prénom de l'enfant *", "Tel qu'il apparaîtra sur l'affiche.", 'type="text" name="properties[Prénom]" maxlength="30" placeholder="Léo" autocomplete="off" required');
    else h += inp("n", "names", "Prénoms *", T === "lune" ? "Un ou deux prénoms, ou un mot qui vous ressemble." : "Un prénom ou deux, tels qu'ils apparaîtront sur l'affiche.", 'type="text" name="properties[Prénoms]" maxlength="40" placeholder="Léa &amp; Thomas" autocomplete="off" required');
    var dateBlock = function (lab, hint) {
      return '<div class="fy-2"><div><label for="fy-d-' + S + '">' + lab + ' *</label><input type="date" id="fy-d-' + S + '" data-fy="date" form="' + F + '" min="1900-01-01" max="2100-12-31" required></div>' +
        '<div><label for="fy-h-' + S + '">Heure</label><input type="time" id="fy-h-' + S + '" data-fy="time" form="' + F + '"></div></div>' +
        '<small style="margin-top:-10px">' + hint + '</small><input type="hidden" data-fy="dateprop" data-fy-time="1" name="properties[Date et heure]" form="' + F + '">';
    };
    var placeBlock = inp("l", "place", T === "naissance" ? "Lieu de naissance *" : "Lieu *", "Commencez à taper, puis choisissez la ville dans la liste.", 'type="text" name="properties[Lieu]" maxlength="45" placeholder="Paris, France" role="combobox" aria-autocomplete="list" aria-expanded="false" required') +
      '<input type="hidden" data-fy="coords" name="properties[_Coordonnées]" form="' + F + '">';
    if (T === "film") {
      h += inp("t", "filmtitle", "Titre du film *", "Court et percutant, 25 caractères au plus.", 'type="text" name="properties[Titre du film]" maxlength="25" placeholder="Nous Deux" required') +
        '<div class="fy-2"><div><label for="fy-d-' + S + '">Date de votre histoire *</label><input type="date" id="fy-d-' + S + '" data-fy="date" form="' + F + '" min="1900-01-01" max="2100-12-31" required></div>' +
        '<div><label for="fy-v-' + S + '">Ville</label><input type="text" id="fy-v-' + S + '" data-fy="city" name="properties[Ville]" form="' + F + '" maxlength="30" placeholder="Paris"></div></div>' +
        '<input type="hidden" data-fy="dateprop" data-fy-time="0" name="properties[Date]" form="' + F + '">' +
        inp("a", "tagline", "Phrase d'accroche", "Facultatif. Par défaut : « Une histoire vraie. La vôtre. »", 'type="text" name="properties[Accroche]" maxlength="45" placeholder="Une histoire vraie. La vôtre."');
    } else if (T === "naissance") {
      h += dateBlock("Date de naissance", "L'heure exacte rend le ciel exact. Inconnue ? Laissez vide (21h00).") + placeBlock +
        '<div class="fy-2"><div><label for="fy-w-' + S + '">Poids</label><input type="text" id="fy-w-' + S + '" data-fy="weight" name="properties[Poids]" form="' + F + '" maxlength="10" placeholder="3,250 kg"></div>' +
        '<div><label for="fy-s-' + S + '">Taille</label><input type="text" id="fy-s-' + S + '" data-fy="height" name="properties[Taille]" form="' + F + '" maxlength="8" placeholder="50 cm"></div></div>' +
        inp("a", "skytitle", "Titre", "Facultatif. Par défaut : « Bienvenue au monde ».", 'type="text" name="properties[Titre]" maxlength="40" placeholder="Bienvenue au monde"');
    } else if (T === "lune") {
      h += dateBlock("Date", "La lune change d'heure en heure. Heure inconnue ? Laissez vide (21h00).") + placeBlock +
        inp("a", "skytitle", "Titre", "Facultatif. Par défaut : « Sous la même lune ».", 'type="text" name="properties[Titre]" maxlength="40" placeholder="Sous la même lune"');
    } else {
      h += dateBlock("Date", "Heure inconnue ? Laissez vide, nous utiliserons 21h00.") + placeBlock;
      if (T === "duo") h += inp("t", "filmtitle", "Titre du film *", "Pour l'affiche style film, 25 caractères au plus.", 'type="text" name="properties[Titre du film]" maxlength="25" placeholder="Nous Deux" required');
      h += inp("a", "skytitle", "Titre de la carte du ciel", "Facultatif. Par défaut : « Là où tout a commencé ».", 'type="text" name="properties[Titre]" maxlength="40" placeholder="Là où tout a commencé"');
    }
    if (T === "film" || T === "duo") {
      h += '<div><label for="fy-p-' + S + '">Votre photo *</label><small>Nette et bien éclairée, de préférence verticale. Elle s\'affiche tout de suite dans l\'aperçu.</small><div class="fy-drop"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1D2433" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="m21 16-5-5-8 8"/></svg><span>Choisir une photo<span class="fy-photo-name">JPG ou PNG</span></span><input type="file" id="fy-p-' + S + '" data-fy="photo" name="properties[Photo]" form="' + F + '" accept="image/jpeg,image/png,image/heic,image/webp"></div></div>' +
        '<div class="fy-c"><input type="checkbox" id="fy-pl-' + S + '" data-fy="photolater" name="properties[Photo par e-mail]" value="Oui" form="' + F + '"><label for="fy-pl-' + S + '">Je préfère envoyer ma photo par e-mail après la commande.</label></div>';
    }
    return h + '<button type="button" class="fy-btn fy-open"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>Prévisualiser mon affiche en grand</button>';
  }
  var FIELDS_CSS=".fy-f{display:flex;flex-direction:column;gap:16px;margin-top:6px}.fy-hd{display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap}.fy-hd p{margin:0;font-weight:700;font-size:1.02rem}.fy-f label{font-weight:600;font-size:.88rem;display:block;margin-bottom:4px}.fy-f small{display:block;font-size:.76rem;color:#6B6152;margin:-2px 0 6px}.fy-f input[type=text],.fy-f input[type=date],.fy-f input[type=time]{width:100%;min-height:48px;padding:12px 14px;border:1px solid rgba(0,0,0,.22);border-radius:10px;font-size:16px;background:#fff;color:#1D2433;font-family:inherit;-webkit-appearance:none;appearance:none}.fy-f input:focus{outline:none;border-color:#0B1426;box-shadow:0 0 0 3px rgba(201,179,126,.35)}.fy-2{display:grid;grid-template-columns:1.4fr 1fr;gap:10px}.fy-c{display:flex;gap:10px;align-items:flex-start;font-size:.85rem}.fy-c input{margin-top:3px;width:18px;height:18px;flex-shrink:0}.fy-c label{font-weight:400;margin:0}.fy-drop{position:relative;display:flex;align-items:center;gap:12px;padding:12px 14px;border:1px dashed rgba(0,0,0,.3);border-radius:10px;background:#FBF9F5;cursor:pointer}.fy-drop:focus-within{border-color:#0B1426;box-shadow:0 0 0 3px rgba(201,179,126,.35)}.fy-drop input{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%}.fy-drop svg{flex-shrink:0}.fy-drop span{font-size:.88rem;color:#1D2433}.fy-drop .fy-photo-name{display:block;font-size:.76rem;color:#6B6152;word-break:break-all}";
  

  /* ---------- polices ---------- */
  var fontsReady = (function () {
    if (!document.querySelector('link[data-fy-fonts]')) {
      var l = document.createElement("link");
      l.rel = "stylesheet"; l.setAttribute("data-fy-fonts", "1");
      l.href = "https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,900&family=Lora:ital,wght@0,400;1,400&family=Poppins:wght@300;500&display=swap";
      document.head.appendChild(l);
    }
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([
      document.fonts.load('italic 40px "Lora"'), document.fonts.load('40px "Lora"'),
      document.fonts.load('300 40px "Poppins"'), document.fonts.load('500 40px "Poppins"'),
      document.fonts.load('900 80px "Inter"'), document.fonts.load('300 40px "Inter"')
    ]).catch(function () {});
  })();

  /* ---------- astronomie ---------- */
  var SKY = null;
  function sky() {
    if (SKY || !window.FY_SKY) return SKY;
    var s = window.FY_SKY.s, n = s.length / 3, st = new Float32Array(n * 4);
    for (var i = 0; i < n; i++) {
      var ra = s[3 * i] * D2R, de = s[3 * i + 1] * D2R;
      st[4 * i] = ra; st[4 * i + 1] = Math.sin(de); st[4 * i + 2] = Math.cos(de); st[4 * i + 3] = s[3 * i + 2];
    }
    SKY = { n: n, st: st, lines: window.FY_SKY.l };
    return SKY;
  }
  function lst(utcMs, lon) {
    var jd = utcMs / 86400000 + 2440587.5, d = jd - 2451545.0, t = d / 36525;
    var g = 280.46061837 + 360.98564736629 * d + 0.000387933 * t * t - t * t * t / 38710000;
    return (((g + lon) % 360) + 360) % 360 * D2R;
  }
  function proj(ra, sd, cd, L, sl, cl) {
    var h = L - ra, ch = Math.cos(h);
    var sa = sd * sl + cd * cl * ch;
    var alt = Math.asin(Math.max(-1, Math.min(1, sa)));
    var az = Math.atan2(-cd * Math.sin(h), sd * cl - cd * sl * ch);
    var r = Math.tan((Math.PI / 2 - alt) / 2);
    return [-r * Math.sin(az), r * Math.cos(az), alt];
  }
  function tzOffsetMin(ms, tz) {
    try {
      var p = new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(new Date(ms));
      var o = {}; p.forEach(function (x) { o[x.type] = +x.value; });
      return (Date.UTC(o.year, o.month - 1, o.day, o.hour % 24, o.minute, o.second) - ms) / 60000;
    } catch (e) { return 60; }
  }
  function localToUtc(y, m, d, hh, mm, tz) {
    var guess = Date.UTC(y, m - 1, d, hh, mm);
    var off = tzOffsetMin(guess, tz);
    var utc = guess - off * 60000;
    var off2 = tzOffsetMin(utc, tz);
    return guess - off2 * 60000;
  }

  /* ---------- dessin ---------- */
  function spaced(ctx, text, cx, y, sp) {
    if (!sp) { ctx.textAlign = "center"; ctx.fillText(text, cx, y); return; }
    ctx.textAlign = "left";
    var ws = [], tot = 0;
    for (var i = 0; i < text.length; i++) { var w = ctx.measureText(text[i]).width; ws.push(w); tot += w; }
    tot += sp * (text.length - 1);
    var x = cx - tot / 2;
    for (i = 0; i < text.length; i++) { ctx.fillText(text[i], x, y); x += ws[i] + sp; }
  }
  function dims(size) {
    var p = (size || "30x40").split("x").map(Number);
    return { w: p[0], h: p[1], wf: p[0] + 0.8, hf: p[1] + 0.8 };
  }
  function frDate(y, m, d) { return d + " " + MONTHS[m - 1] + " " + y; }

  function drawSky(cv, o) {
    var S = sky(); if (!S) return;
    var dm = dims(o.size), ctx = cv.getContext("2d"), W = cv.width, H = cv.height;
    var Hf = H * dm.hf / dm.h, Wf = W * dm.wf / dm.w, Hin = dm.hf / 2.54;
    var pt = function (p) { return p / 72 * Hf / Hin; };
    var th = THEMES[o.theme] || THEMES.nuit;
    ctx.save();
    ctx.fillStyle = th.bg; ctx.fillRect(0, 0, W, H);
    ctx.translate(-(Wf - W) / 2, -(Hf - H) / 2);
    var R = 0.78 * Wf / 2.2, cx = Wf / 2, cy = Hf * (1 - 0.60);
    var utc = localToUtc(o.y, o.m, o.d, o.hh, o.mm, o.tz);
    var L = lst(utc, o.lon), lat = o.lat * D2R, sl = Math.sin(lat), cl = Math.cos(lat);
    var X = function (x) { return cx + x * R; }, Y = function (y) { return cy - y * R; };

    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, R, 0, 2 * Math.PI); ctx.clip();
    ctx.strokeStyle = th.grid; ctx.lineWidth = pt(0.35);
    [30, 60].forEach(function (a) { ctx.beginPath(); ctx.arc(cx, cy, Math.tan((90 - a) * D2R / 2) * R, 0, 2 * Math.PI); ctx.stroke(); });
    for (var az = 0; az < 360; az += 30) {
      var a = az * D2R; ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(X(-Math.sin(a)), Y(Math.cos(a))); ctx.stroke();
    }
    // constellations
    ctx.strokeStyle = th.line; ctx.globalAlpha = 0.75; ctx.lineWidth = pt(0.6); ctx.lineCap = "round";
    ctx.beginPath();
    S.lines.forEach(function (ln) {
      var prev = null;
      for (var i = 0; i < ln.length; i += 2) {
        var de = ln[i + 1] * D2R, p = proj(ln[i] * D2R, Math.sin(de), Math.cos(de), L, sl, cl);
        if (prev && prev[2] > -0.02 && p[2] > -0.02) { ctx.moveTo(X(prev[0]), Y(prev[1])); ctx.lineTo(X(p[0]), Y(p[1])); }
        prev = p;
      }
    });
    ctx.stroke(); ctx.globalAlpha = 1;
    // etoiles
    ctx.fillStyle = th.star;
    var k = Hf / Hin / 72, st = S.st;
    var halo = [];
    for (var i = 0; i < S.n; i++) {
      var p = proj(st[4 * i], st[4 * i + 1], st[4 * i + 2], L, sl, cl);
      if (p[2] <= 0) continue;
      var m = st[4 * i + 3];
      var s = Math.min(60, Math.max(0.15, Math.pow(6.3 - m, 2.1) * 0.55));
      var r = Math.sqrt(s) / 2 * k;
      if (m < 1.8) halo.push([X(p[0]), Y(p[1]), Math.sqrt(s * 6) / 2 * k]);
      ctx.beginPath(); ctx.arc(X(p[0]), Y(p[1]), Math.max(r, 0.35), 0, 2 * Math.PI); ctx.fill();
    }
    ctx.globalAlpha = 0.10;
    halo.forEach(function (h) { ctx.beginPath(); ctx.arc(h[0], h[1], h[2], 0, 2 * Math.PI); ctx.fill(); });
    ctx.globalAlpha = 1;
    ctx.restore();

    ctx.strokeStyle = th.ring;
    ctx.lineWidth = pt(1.6); ctx.beginPath(); ctx.arc(cx, cy, R, 0, 2 * Math.PI); ctx.stroke();
    ctx.lineWidth = pt(0.5); ctx.beginPath(); ctx.arc(cx, cy, 1.025 * R, 0, 2 * Math.PI); ctx.stroke();
    ctx.fillStyle = th.fg; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.font = "500 " + pt(7) + 'px "Poppins"';
    [["N", 0, 1.075], ["S", 0, -1.075], ["E", -1.075, 0], ["O", 1.075, 0]].forEach(function (c) { ctx.fillText(c[0], X(c[1]), Y(c[2])); });

    var top = 0.60 - 0.39 * Wf / Hf - 0.045, fy = function (f) { return Hf * (1 - f); };
    var tx = function (yf, s, font, alpha) { ctx.globalAlpha = alpha || 1; ctx.font = font; ctx.fillText(s, Wf / 2, fy(yf)); ctx.globalAlpha = 1; };
    var u = Hf / (15.75 * 72);
    tx(top, o.title, "italic " + (30 * u) + 'px "Lora"');
    tx(top - 0.055, o.names, (20 * u) + 'px "Lora"');
    var sub = (o.place ? o.place.toUpperCase() + "  ·  " : "") + frDate(o.y, o.m, o.d).toUpperCase() + "  ·  " + pad(o.hh) + ":" + pad(o.mm);
    tx(top - 0.105, sub, "300 " + (9.5 * u) + 'px "Poppins"', 0.9);
    var coord = Math.abs(o.lat).toFixed(4) + "° " + (o.lat >= 0 ? "N" : "S") + "  ·  " + Math.abs(o.lon).toFixed(4) + "° " + (o.lon >= 0 ? "E" : "O");
    tx(top - 0.135, coord, "300 " + (8 * u) + 'px "Poppins"', 0.7);
    if (o.extra) tx(top - 0.165, o.extra.toUpperCase(), "500 " + (8.5 * u) + 'px "Poppins"', 0.85);
    ctx.strokeStyle = th.ring; ctx.lineWidth = pt(0.6);
    ctx.beginPath(); ctx.moveTo(0.42 * Wf, fy(top - 0.08)); ctx.lineTo(0.58 * Wf, fy(top - 0.08)); ctx.stroke();
    ctx.restore();
  }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function drawFilm(cv, o) {
    var dm = dims(o.size), ctx = cv.getContext("2d"), W = cv.width, H = cv.height;
    var Hf = H * dm.hf / dm.h, Wf = W * dm.wf / dm.w, s = Hf / 4818;
    ctx.save();
    ctx.fillStyle = "rgb(8,8,10)"; ctx.fillRect(0, 0, W, H);
    ctx.translate(-(Wf - W) / 2, -(Hf - H) / 2);
    var ph = o.photo, pw = Wf, phh = Hf * 0.82;
    if (ph && ph.naturalWidth) {
      var ir = ph.naturalWidth / ph.naturalHeight, tr = pw / phh, sx, sy, sw, sh;
      if (ir > tr) { sh = ph.naturalHeight; sw = sh * tr; sx = (ph.naturalWidth - sw) / 2; sy = 0; }
      else { sw = ph.naturalWidth; sh = sw / tr; sx = 0; sy = (ph.naturalHeight - sh) * (o.cropY == null ? 0.35 : o.cropY); }
      ctx.drawImage(ph, sx, sy, sw, sh, 0, 0, pw, phh);
    } else {
      var g0 = ctx.createLinearGradient(0, 0, 0, phh);
      g0.addColorStop(0, "#1d2340"); g0.addColorStop(0.6, "#7a4a52"); g0.addColorStop(1, "#c98a62");
      ctx.fillStyle = g0; ctx.fillRect(0, 0, pw, phh);
    }
    var g = ctx.createLinearGradient(0, 0, 0, Hf);
    for (var i = 0; i <= 20; i++) {
      var f = i / 20, t = Math.min(1, Math.max(0, (f - 0.45) / 0.37));
      g.addColorStop(f, "rgba(8,8,10," + Math.pow(t, 1.4).toFixed(3) + ")");
    }
    ctx.fillStyle = g; ctx.fillRect(0, 0, Wf, Hf);
    var v = ctx.createLinearGradient(0, 0, 0, Hf * 0.16);
    v.addColorStop(0, "rgba(8,8,10," + (150 / 255).toFixed(3) + ")"); v.addColorStop(1, "rgba(8,8,10,0)");
    ctx.fillStyle = v; ctx.fillRect(0, 0, Wf, Hf * 0.16);

    var cx = Wf / 2, white = "rgb(245,240,230)";
    ctx.textBaseline = "top"; ctx.fillStyle = white;
    ctx.font = "500 " + 70 * s + 'px "Poppins"'; spaced(ctx, o.names.toUpperCase(), cx, 150 * s, 18 * s);
    var t = o.title.toUpperCase(), sz = 520 * s;
    ctx.font = "900 " + sz + 'px "Inter"';
    while (ctx.measureText(t).width > Wf * 0.86 && sz > 120 * s) { sz *= 0.94; ctx.font = "900 " + sz + 'px "Inter"'; }
    var yt = Hf * 0.70;
    ctx.textAlign = "center"; ctx.fillText(t, cx, yt);
    ctx.font = "italic " + 92 * s + 'px "Lora"'; ctx.fillText(o.tagline, cx, yt + sz * 0.98);
    var dt = "DEPUIS LE " + o.d + " " + MONTHS[o.m - 1].toUpperCase() + " " + o.y + (o.place ? "  ·  " + o.place.toUpperCase() : "");
    ctx.font = "500 " + 64 * s + 'px "Poppins"'; spaced(ctx, dt, cx, Hf * 0.865, 10 * s);
    var nm = o.names.split("&"), a = (nm[0] || "").trim(), b = (nm[1] || "").trim();
    var credits = "UNE HISTOIRE DE " + a.toUpperCase() + (b ? " ET " + b.toUpperCase() : "") +
      "   RÉALISÉE PAR LE HASARD   SCÉNARIO LE DESTIN   MUSIQUE VOS RIRES   PRODUCTION FOYENA   AVEC LA PARTICIPATION DE TOUS CEUX QUI VOUS AIMENT";
    ctx.font = "300 " + 38 * s + 'px "Inter"'; ctx.fillStyle = "rgb(200,196,188)"; ctx.textAlign = "center";
    var words = credits.split("   "), lines = [], cur = "";
    words.forEach(function (w) { var tr = cur ? cur + "   " + w : w; if (ctx.measureText(tr).width > Wf * 0.8) { lines.push(cur); cur = w; } else cur = tr; });
    lines.push(cur);
    var yc = Hf * 0.905; lines.forEach(function (l) { ctx.fillText(l, cx, yc); yc += 52 * s; });
    ctx.fillStyle = "rgb(120,118,112)"; ctx.font = "300 " + 30 * s + 'px "Poppins"';
    spaced(ctx, "FOYENA.COM", cx, Hf - 110 * s, 8 * s);
    ctx.restore();
  }

  /* ---------- lune (meme calcul que moon.py) ---------- */
  function nrm(a) { return ((a % 360) + 360) % 360; }
  var PH = [[11.25, "Nouvelle lune"], [78.75, "Premier croissant"], [101.25, "Premier quartier"], [168.75, "Gibbeuse croissante"], [191.25, "Pleine lune"], [258.75, "Gibbeuse décroissante"], [281.25, "Dernier quartier"], [348.75, "Dernier croissant"], [361, "Nouvelle lune"]];
  function eclEq(l, b) {
    l *= D2R; b *= D2R; var e = 23.4393 * D2R;
    return [((Math.atan2(Math.sin(l) * Math.cos(e) - Math.tan(b) * Math.sin(e), Math.cos(l))) + 2 * Math.PI) % (2 * Math.PI), Math.asin(Math.sin(b) * Math.cos(e) + Math.cos(b) * Math.sin(e) * Math.sin(l))];
  }
  function moonState(utc, lat, lon) {
    var jd = utc / 86400000 + 2440587.5, T = (jd - 2451545) / 36525, s = function (x) { return Math.sin(x * D2R); };
    var M = nrm(357.52911 + 35999.05029 * T), L0 = nrm(280.46646 + 36000.76983 * T);
    var ls = nrm(L0 + (1.914602 - 0.004817 * T) * s(M) + 0.019993 * s(2 * M) + 0.000289 * s(3 * M));
    var Lp = nrm(218.3164477 + 481267.88123421 * T), D = nrm(297.8501921 + 445267.1114034 * T), Mp = nrm(134.9633964 + 477198.8675055 * T), F = nrm(93.272095 + 483202.0175233 * T);
    var lm = Lp + 6.288774 * s(Mp) + 1.274027 * s(2 * D - Mp) + 0.658314 * s(2 * D) + 0.213618 * s(2 * Mp) - 0.185116 * s(M) - 0.114332 * s(2 * F) + 0.058793 * s(2 * D - 2 * Mp) + 0.057066 * s(2 * D - M - Mp) + 0.053322 * s(2 * D + Mp) + 0.045758 * s(2 * D - M) - 0.040923 * s(M - Mp) - 0.03472 * s(D) - 0.030383 * s(M + Mp);
    var bm = 5.128122 * s(F) + 0.280602 * s(Mp + F) + 0.277693 * s(Mp - F) + 0.173237 * s(2 * D - F) + 0.055413 * s(2 * D - F + Mp) + 0.046271 * s(2 * D - F - Mp) + 0.032573 * s(2 * D + F) + 0.017198 * s(2 * Mp + F);
    lm = nrm(lm);
    var el = nrm(lm - ls), psi = Math.acos(Math.cos(bm * D2R) * Math.cos((lm - ls) * D2R)), i = Math.PI - psi, k = (1 + Math.cos(i)) / 2;
    var es = eclEq(ls, 0), em = eclEq(lm, bm), ras = es[0], ds = es[1], ram = em[0], dm = em[1];
    var chi = Math.atan2(Math.cos(ds) * Math.sin(ras - ram), Math.sin(ds) * Math.cos(dm) - Math.cos(ds) * Math.sin(dm) * Math.cos(ras - ram));
    var d = jd - 2451545, t = d / 36525, g = nrm(280.46061837 + 360.98564736629 * d + 0.000387933 * t * t - t * t * t / 38710000);
    var H = (g + lon) * D2R - ram, phi = lat * D2R;
    var q = Math.atan2(Math.sin(H), Math.tan(phi) * Math.cos(dm) - Math.sin(dm) * Math.cos(H));
    var name = "Nouvelle lune"; for (var j = 0; j < PH.length; j++) if (el < PH[j][0]) { name = PH[j][1]; break; }
    return { i: i, k: k, chi: chi, q: q, name: name };
  }
  var MOONTH = {
    nuit: { lit: [246, 240, 226], dark: [16, 27, 48], glow: "201,179,126", earth: 0.035 },
    creme: { lit: [252, 249, 243], dark: [228, 220, 206], glow: null, earth: 0 },
    minuit: { lit: [242, 242, 240], dark: [12, 12, 13], glow: "255,255,255", earth: 0.035 }
  };
  var TEX = null, texReady = false;
  function moonTex() {
    if (TEX) return texReady ? TEX : null;
    TEX = { img: new Image(), n: 0, a: null };
    TEX.img.crossOrigin = "anonymous";
    TEX.img.onload = function () {
      var n = TEX.img.naturalWidth, c = document.createElement("canvas"); c.width = c.height = n;
      var x = c.getContext("2d"); x.drawImage(TEX.img, 0, 0);
      var d = x.getImageData(0, 0, n, n).data, a = new Float32Array(n * n);
      for (var p = 0; p < n * n; p++) a[p] = d[4 * p] / 255;
      TEX.n = n; TEX.a = a; texReady = true; schedule();
    };
    TEX.img.src = cfg.moonTex || "";
    return null;
  }
  var discCache = {};
  function moonDisc(size, st, thn) {
    var key = size + "|" + st.i.toFixed(4) + "|" + st.chi.toFixed(4) + "|" + st.q.toFixed(4) + "|" + thn;
    if (discCache.key === key) return discCache.cv;
    var T = moonTex(), th = MOONTH[thn] || MOONTH.nuit;
    var c = document.createElement("canvas"); c.width = c.height = size;
    var x = c.getContext("2d"), im = x.createImageData(size, size), px = im.data;
    var rot = -st.q, cr = Math.cos(rot), sr = Math.sin(rot);
    var bx = -Math.sin(st.chi), by = Math.cos(st.chi), Sx = Math.sin(st.i) * bx, Sy = Math.sin(st.i) * by, Sz = Math.cos(st.i);
    var n = T ? T.n : 0;
    for (var yy = 0; yy < size; yy++) {
      var y = 1 - (yy + 0.5) / size * 2;
      for (var xx = 0; xx < size; xx++) {
        var xq = (xx + 0.5) / size * 2 - 1, r2 = xq * xq + y * y, o = 4 * (yy * size + xx);
        if (r2 > 1) { px[o + 3] = 0; continue; }
        var z = Math.sqrt(1 - r2), tx = xq * cr - y * sr, ty = xq * sr + y * cr;
        var lam = tx * Sx + ty * Sy + z * Sz;
        var light = Math.min(1, Math.max(0, (lam + 0.02) / 0.04)) * (0.55 + 0.45 * Math.sqrt(Math.max(0, lam)));
        var alb = 0.7;
        if (T) { var u = Math.min(n - 1, Math.max(0, ((tx + 1) / 2 * n) | 0)), v = Math.min(n - 1, Math.max(0, ((1 - ty) / 2 * n) | 0)); alb = T.a[v * n + u]; }
        var a = alb * (0.82 + 0.18 * z);
        for (var ch = 0; ch < 3; ch++) {
          var cl = th.lit[ch] * a * 1.18, cd = th.dark[ch] * (1 - th.earth) + th.lit[ch] * a * th.earth;
          px[o + ch] = Math.min(255, cd + (cl - cd) * light);
        }
        px[o + 3] = Math.min(1, (1 - Math.sqrt(r2)) * size / 2) * 255;
      }
    }
    x.putImageData(im, 0, 0);
    if (T) { discCache.key = key; discCache.cv = c; }
    return c;
  }
  function drawMoon(cv, o) {
    var dm = dims(o.size), ctx = cv.getContext("2d"), W = cv.width, H = cv.height;
    var Hf = H * dm.hf / dm.h, Wf = W * dm.wf / dm.w, Hin = dm.hf / 2.54, pt = function (p) { return p / 72 * Hf / Hin; };
    var th = THEMES[o.theme] || THEMES.nuit, mt = MOONTH[o.theme] || MOONTH.nuit;
    var st = moonState(localToUtc(o.y, o.m, o.d, o.hh, o.mm, o.tz), o.lat, o.lon);
    ctx.save(); ctx.fillStyle = th.bg; ctx.fillRect(0, 0, W, H);
    ctx.translate(-(Wf - W) / 2, -(Hf - H) / 2);
    var D = 0.78 * Wf / 1.1 * 0.93, cx = Wf / 2, cy = Hf * (1 - 0.60);
    if (mt.glow) {
      var g = ctx.createRadialGradient(cx, cy, D * 0.3, cx, cy, D * 0.75), al = (70 * st.k + 20) / 255 * 0.45;
      g.addColorStop(0, "rgba(" + mt.glow + "," + al.toFixed(3) + ")"); g.addColorStop(1, "rgba(" + mt.glow + ",0)");
      ctx.fillStyle = g; ctx.fillRect(0, 0, Wf, Hf);
    }
    ctx.drawImage(moonDisc(Math.max(64, Math.round(D)), st, o.theme), cx - D / 2, cy - D / 2, D, D);
    ctx.fillStyle = th.fg; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    var top = 0.60 - 0.39 * Wf / Hf - 0.045, fy = function (f) { return Hf * (1 - f); }, u = Hf / (15.75 * 72);
    var tx = function (yf, s, font, alpha) { ctx.globalAlpha = alpha || 1; ctx.font = font; ctx.fillText(s, Wf / 2, fy(yf)); ctx.globalAlpha = 1; };
    tx(top, o.title, "italic " + (30 * u) + 'px "Lora"');
    tx(top - 0.055, o.names, (20 * u) + 'px "Lora"');
    tx(top - 0.105, (o.place ? o.place.toUpperCase() + "  ·  " : "") + frDate(o.y, o.m, o.d).toUpperCase() + "  ·  " + pad(o.hh) + ":" + pad(o.mm), "300 " + (9.5 * u) + 'px "Poppins"', 0.9);
    tx(top - 0.135, st.name.toUpperCase() + "  ·  " + Math.round(st.k * 100) + " % ÉCLAIRÉE", "300 " + (8 * u) + 'px "Poppins"', 0.7);
    ctx.strokeStyle = o.theme === "nuit" ? "#C9B37E" : th.fg; ctx.lineWidth = pt(0.6);
    ctx.beginPath(); ctx.moveTo(0.42 * Wf, fy(top - 0.08)); ctx.lineTo(0.58 * Wf, fy(top - 0.08)); ctx.stroke();
    ctx.restore();
    return st;
  }

  /* ---------- geocodage (Photon / OpenStreetMap) ---------- */
  var TZ = { FR: "Europe/Paris", BE: "Europe/Brussels", CH: "Europe/Zurich", LU: "Europe/Luxembourg", MC: "Europe/Monaco", DE: "Europe/Berlin", IT: "Europe/Rome", ES: "Europe/Madrid", PT: "Europe/Lisbon", GB: "Europe/London", IE: "Europe/Dublin", NL: "Europe/Amsterdam", AT: "Europe/Vienna", PL: "Europe/Warsaw", GR: "Europe/Athens", MA: "Africa/Casablanca", DZ: "Africa/Algiers", TN: "Africa/Tunis", SN: "Africa/Dakar", CI: "Africa/Abidjan", CM: "Africa/Douala", GA: "Africa/Libreville", CG: "Africa/Brazzaville", CD: "Africa/Kinshasa", ML: "Africa/Bamako", MG: "Indian/Antananarivo", RE: "Indian/Reunion", GP: "America/Guadeloupe", MQ: "America/Martinique", GF: "America/Cayenne", YT: "Indian/Mayotte", NC: "Pacific/Noumea", PF: "Pacific/Tahiti", TR: "Europe/Istanbul", JP: "Asia/Tokyo", CN: "Asia/Shanghai", IN: "Asia/Kolkata", TH: "Asia/Bangkok", VN: "Asia/Ho_Chi_Minh", AE: "Asia/Dubai", IL: "Asia/Jerusalem", EG: "Africa/Cairo", ZA: "Africa/Johannesburg", NZ: "Pacific/Auckland", AR: "America/Argentina/Buenos_Aires", CO: "America/Bogota", PE: "America/Lima", CL: "America/Santiago", HT: "America/Port-au-Prince", DK: "Europe/Copenhagen", SE: "Europe/Stockholm", NO: "Europe/Oslo", FI: "Europe/Helsinki", CZ: "Europe/Prague", HU: "Europe/Budapest", RO: "Europe/Bucharest", HR: "Europe/Zagreb", MU: "Indian/Mauritius" };
  function tzFor(cc, lat, lon) {
    if (TZ[cc]) return TZ[cc];
    if (cc === "US") return lon > -87.5 ? "America/New_York" : lon > -101 ? "America/Chicago" : lon > -115 ? "America/Denver" : lon > -140 ? "America/Los_Angeles" : "Pacific/Honolulu";
    if (cc === "CA") return lon > -64 ? "America/Halifax" : lon > -90 ? "America/Toronto" : lon > -102 ? "America/Winnipeg" : lon > -120 ? "America/Edmonton" : "America/Vancouver";
    var h = Math.round(lon / 15);
    return h === 0 ? "Etc/GMT" : "Etc/GMT" + (h > 0 ? "-" : "+") + Math.abs(h);
  }
  var geoCache = {};
  function geocode(q) {
    q = q.trim(); if (q.length < 2) return Promise.resolve([]);
    if (geoCache[q]) return Promise.resolve(geoCache[q]);
    return fetch("https://photon.komoot.io/api/?limit=5&lang=fr&osm_tag=place&q=" + encodeURIComponent(q))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var out = (j.features || []).map(function (f) {
          var p = f.properties, c = f.geometry.coordinates;
          var region = p.state && p.state !== p.name ? p.state : "";
          return { name: p.name, label: p.name + (p.country ? ", " + p.country : ""), detail: [region, p.country].filter(Boolean).join(", "),
            lat: c[1], lon: c[0], tz: tzFor((p.countrycode || "").toUpperCase(), c[1], c[0]) };
        });
        geoCache[q] = out; return out;
      }).catch(function () { return []; });
  }

  /* ---------- styles ---------- */
  var css = "" +
    ".fy-stage{position:sticky;top:calc(var(--header-height,64px) + 16px);display:none;flex-direction:column;gap:14px}" +
    ".fy-stage.on{display:flex}" +
    ".fy-wall{position:relative;border-radius:8px;overflow:hidden;background:radial-gradient(120% 90% at 30% 10%,#F1ECE3 0%,#E2DACD 55%,#D3C9BA 100%);display:flex;align-items:center;justify-content:center;gap:5%;padding:7% 6% 9%;min-height:min(78vh,860px)}" +
    ".fy-wall:after{content:'';position:absolute;left:0;right:0;bottom:0;height:7%;background:linear-gradient(#cfc5b5,#c4b9a8)}" +
    ".fy-frame{position:relative;z-index:1;background:#F8F6F1;padding:3.5%;border:clamp(6px,1.1vw,14px) solid #1C1A18;box-shadow:0 2px 3px rgba(40,30,20,.25),18px 30px 50px -12px rgba(40,30,20,.45);transition:transform .5s cubic-bezier(.2,.7,.2,1)}" +
    ".fy-frame canvas{display:block;width:100%;height:auto;box-shadow:inset 0 0 0 1px rgba(0,0,0,.06)}" +
    ".fy-frame.fy-creme{padding:0;background:#1C1A18}.fy-frame.fy-creme canvas{box-shadow:0 0 0 1px rgba(0,0,0,.35)}" +
    ".fy-stage .fy-frame{width:min(72%,calc((80vh - 110px)*.75))}.fy-stage.duo .fy-frame{width:46%}" +
    ".fy-bar{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap}" +
    ".fy-tabs{display:inline-flex;background:#F1ECE3;border-radius:999px;padding:4px}" +
    ".fy-tabs button{border:0;background:transparent;padding:8px 16px;border-radius:999px;font:500 .85rem/1 inherit;color:#5d5446;cursor:pointer}" +
    ".fy-tabs button[aria-pressed=true]{background:#0B1426;color:#F4EEE3}" +
    ".fy-tabs button:focus-visible,.fy-btn:focus-visible,.fy-x:focus-visible{outline:2px solid #C9B37E;outline-offset:2px}" +
    ".fy-note{margin:0;font-size:.8rem;color:#6B6152;line-height:1.45}" +
    ".fy-dot{display:inline-block;width:7px;height:7px;border-radius:50%;background:#3E9B6A;margin-right:7px;vertical-align:1px;box-shadow:0 0 0 0 rgba(62,155,106,.5);animation:fyp 2.4s infinite}" +
    "@keyframes fyp{70%{box-shadow:0 0 0 7px rgba(62,155,106,0)}100%{box-shadow:0 0 0 0 rgba(62,155,106,0)}}" +
    "@media (prefers-reduced-motion:reduce){.fy-dot{animation:none}.fy-frame{transition:none}}" +
    ".fy-inline{display:none;margin:2px 0 4px}" +
    "@media (max-width:989px){.fy-inline{display:block}.fy-stage{display:none!important}}" +
    ".fy-inline .fy-wall{min-height:0;padding:9% 8% 12%}.fy-inline .fy-frame{width:74%}.fy-inline.duo .fy-frame{width:47%}" +
    ".fy-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 16px;border-radius:10px;border:1px solid #0B1426;background:#fff;color:#0B1426;font:600 .92rem/1.2 inherit;cursor:pointer}" +
    ".fy-btn:hover{background:#F4EEE3}" +
    ".fy-modal{position:fixed;inset:0;z-index:2147483000;background:rgba(11,20,38,.92);display:none;flex-direction:column;align-items:center;justify-content:center;padding:20px;gap:18px}" +
    ".fy-modal.on{display:flex}" +
    ".fy-modal .fy-wall{width:min(1100px,100%);min-height:0;height:min(80vh,820px);padding:4% 5% 6%}" +
    ".fy-modal .fy-frame{height:86%;width:auto;display:flex;align-items:center}.fy-modal .fy-frame canvas{height:100%;width:auto}" +
    ".fy-modal .fy-mrow{display:flex;gap:10px;align-items:center;flex-wrap:wrap;justify-content:center}" +
    ".fy-modal .fy-tabs{background:rgba(255,255,255,.08)}.fy-modal .fy-tabs button{color:#E8DFCC}.fy-modal .fy-tabs button[aria-pressed=true]{background:#F4EEE3;color:#0B1426}" +
    ".fy-modal .fy-cta{border:0;background:#C9B37E;color:#0B1426;padding:12px 22px;border-radius:999px;font:600 .95rem/1 inherit;cursor:pointer}" +
    ".fy-x{position:absolute;top:14px;right:16px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.1);color:#fff;font-size:22px;cursor:pointer}" +
    ".fy-sug{position:absolute;left:0;right:0;top:100%;z-index:20;background:#fff;border:1px solid rgba(0,0,0,.15);border-radius:10px;margin-top:4px;box-shadow:0 12px 30px rgba(0,0,0,.12);overflow:hidden}" +
    ".fy-sug button{display:block;width:100%;text-align:left;border:0;background:#fff;padding:10px 14px;font:inherit;font-size:.92rem;cursor:pointer}" +
    ".fy-sug button small{display:block;opacity:.6;font-size:.76rem}" +
    ".fy-sug button:hover,.fy-sug button.act{background:#F4EEE3}" +
    ".fy-sug .fy-osm{padding:6px 14px;font-size:.68rem;opacity:.55}" +
    ".fy-f,.fy-f *,.fy-stage,.fy-stage *,.fy-modal,.fy-modal *,.fy-mini,.fy-mini *{box-sizing:border-box}" +
    ".fy-mini{position:fixed;right:14px;bottom:14px;z-index:2147482000;width:112px;border:0;padding:0;background:none;cursor:pointer;display:none;filter:drop-shadow(0 10px 22px rgba(11,20,38,.35))}" +
    ".fy-mini.on{display:block}.fy-mini.duo{width:150px}" +
    ".fy-mini .fy-wall{min-height:0;padding:10px;border-radius:12px;gap:6px}.fy-mini .fy-wall:after{display:none}.fy-mini .fy-frame{width:100%;padding:6%;border-width:3px;box-shadow:none}.fy-mini.duo .fy-frame{width:48%}" +
    ".fy-mini span{display:block;margin-top:6px;font:600 .72rem/1.2 inherit;color:#fff;background:#0B1426;border-radius:999px;padding:6px 8px;text-align:center}" +
    "@media (min-width:990px){.fy-mini{display:none!important}}" +
    ".fy-frame:before{content:'';position:absolute;inset:0;z-index:2;pointer-events:none;opacity:0;transition:opacity .4s;background:radial-gradient(circle at var(--gx,50%) var(--gy,30%),rgba(255,255,255,.22),rgba(255,255,255,0) 55%);mix-blend-mode:soft-light}" +
    "@media (hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference){.fy-stage .fy-wall,.fy-modal .fy-wall{perspective:1400px}.fy-tilt .fy-frame{transition:transform .12s ease-out,box-shadow .12s ease-out;will-change:transform}.fy-tilt .fy-frame:before{opacity:1}}" +
    ".fy-modal .fy-frame{height:90%}";
  var st = document.createElement("style"); st.textContent = css + FIELDS_CSS; document.head.appendChild(st);

  /* ---------- lecture du formulaire ---------- */
  function root() { return document.querySelector(".fy-f[data-fy-type]"); }
  function val(r, k) { var e = r.querySelector('[data-fy="' + k + '"]'); return e ? (e.value || "").trim() : ""; }
  function variantInfo() {
    var styleV = "Bleu nuit", sizeV = "30×40";
    document.querySelectorAll('input[type=radio][name*="variant_picker"]:checked').forEach(function (i) {
      var v = i.value || "";
      if (/nuit|crème|creme|minuit/i.test(v)) styleV = v;
      if (/\d+\s*×\s*\d+/.test(v)) sizeV = v;
    });
    var theme = /crème|creme/i.test(styleV) ? "creme" : /minuit/i.test(styleV) ? "minuit" : "nuit";
    return { theme: theme, size: /50/.test(sizeV) ? "50x70" : "30x40", styleLabel: styleV };
  }
  var place = { label: "Paris, France", lat: 48.8566, lon: 2.3522, tz: "Europe/Paris", typed: "" };
  var photoImg = null, demoImg = null;
  if (cfg.demoPhoto) { demoImg = new Image(); demoImg.onload = function () { schedule(); }; demoImg.src = cfg.demoPhoto; }

  function state() {
    var r = root(); if (!r) return null;
    var type = r.getAttribute("data-fy-type"), vi = variantInfo();
    var DEF = { naissance: ["Léo", "Bienvenue au monde"], lune: ["Léa & Thomas", "Sous la même lune"] }[type] || ["Léa & Thomas", "Là où tout a commencé"];
    var names = val(r, "names") || DEF[0];
    var dt = val(r, "date"), tm = val(r, "time");
    var y = 2019, m = 2, d = 14, hh = 21, mm = 30;
    var md = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dt);
    if (md) { y = +md[1]; m = +md[2]; d = +md[3]; hh = 21; mm = 0; }
    var mt = /^(\d{2}):(\d{2})/.exec(tm);
    if (mt) { hh = +mt[1]; mm = +mt[2]; }
    var typedPlace = val(r, "place") || val(r, "city");
    var placeTxt = typedPlace || "Paris, France";
    return {
      type: type, theme: vi.theme, size: vi.size,
      sky: { y: y, m: m, d: d, hh: hh, mm: mm, tz: place.tz, lat: place.lat, lon: place.lon, place: placeTxt,
        title: val(r, "skytitle") || DEF[1], names: names, theme: vi.theme, size: vi.size,
        extra: type === "naissance" ? [val(r, "weight"), val(r, "height")].filter(Boolean).join("  ·  ") || (val(r, "names") ? "" : "3,250 kg  ·  50 cm") : "" },
      film: { y: y, m: m, d: d, names: names, title: val(r, "filmtitle") || "Nous Deux",
        tagline: val(r, "tagline") || "Une histoire vraie. La vôtre.",
        place: (typedPlace || "Paris").split(",")[0].trim(), size: vi.size,
        photo: photoImg || demoImg, cropY: photoImg ? 0.35 : 0.62 }
    };
  }

  /* ---------- rendu dans toutes les scenes ---------- */
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; renderAll(); }); }
  function sizeCanvas(cv, size, widthPx) {
    var dm = dims(size), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.round(widthPx * dpr), h = Math.round(w * dm.h / dm.w);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
  }
  function renderScene(scene, s) {
    if (!scene || !s) return;
    var duo = s.type === "duo";
    scene.classList.toggle("duo", duo);
    var wall = scene.querySelector(".fy-wall");
    var frames = wall.querySelectorAll(".fy-frame");
    var need = duo ? 2 : 1;
    if (frames.length !== need) {
      wall.querySelectorAll(".fy-frame").forEach(function (f) { f.remove(); });
      for (var i = 0; i < need; i++) { var f = document.createElement("div"); f.className = "fy-frame"; f.appendChild(document.createElement("canvas")); wall.appendChild(f); }
      frames = wall.querySelectorAll(".fy-frame");
    }
    if (!scene.classList.contains("fy-inline") && !scene.classList.contains("fy-mini")) wireTilt(wall);
    var target = scene.classList.contains("fy-modal") ? 1100 : scene.classList.contains("fy-mini") ? 160 : 700;
    var kinds = duo ? ["ciel", "film"] : [s.type];
    kinds.forEach(function (k, i) {
      var cv = frames[i].querySelector("canvas");
      cv.setAttribute("role", "img");
      cv.setAttribute("aria-label", k === "film" ? "Aperçu de votre affiche style film" : k === "lune" ? "Aperçu de votre affiche lune" : k === "naissance" ? "Aperçu de votre affiche de naissance" : "Aperçu de votre carte du ciel");
      sizeCanvas(cv, s.size, duo ? target * 0.5 : target * 0.7);
      frames[i].classList.toggle("fy-creme", s.theme === "creme" && (k !== "film" || duo));
      if (k === "film") drawFilm(cv, s.film); else if (k === "lune") drawMoon(cv, s.sky); else drawSky(cv, s.sky);
    });
  }
  function renderAll() {
    var s = state(); if (!s) return;
    document.querySelectorAll(".fy-scene").forEach(function (sc) {
      if (sc.offsetParent !== null || sc.classList.contains("on")) renderScene(sc, s);
    });
  }


  /* ---------- inclinaison 3D du cadre au survol (ordinateur uniquement) ---------- */
  var canTilt = window.matchMedia && matchMedia("(hover:hover) and (pointer:fine)").matches && !matchMedia("(prefers-reduced-motion: reduce)").matches;
  function wireTilt(wall) {
    if (!canTilt || !wall || wall.dataset.fyTilt) return; wall.dataset.fyTilt = "1";
    var raf = null, px = 0, py = 0;
    function apply() {
      raf = null;
      wall.querySelectorAll(".fy-frame").forEach(function (f) {
        f.style.transform = "rotateY(" + (px * 7).toFixed(2) + "deg) rotateX(" + (-py * 5).toFixed(2) + "deg) translateZ(0)";
        f.style.boxShadow = "0 2px 3px rgba(40,30,20,.25)," + (18 - px * 22).toFixed(1) + "px " + (30 - py * 18).toFixed(1) + "px 50px -12px rgba(40,30,20,.5)";
        f.style.setProperty("--gx", (50 + px * 60).toFixed(1) + "%"); f.style.setProperty("--gy", (30 + py * 50).toFixed(1) + "%");
      });
    }
    wall.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse") return;
      var r = wall.getBoundingClientRect();
      px = Math.max(-1, Math.min(1, (e.clientX - r.left) / r.width * 2 - 1));
      py = Math.max(-1, Math.min(1, (e.clientY - r.top) / r.height * 2 - 1));
      wall.classList.add("fy-tilt"); if (!raf) raf = requestAnimationFrame(apply);
    });
    wall.addEventListener("pointerleave", function () {
      wall.classList.remove("fy-tilt");
      wall.querySelectorAll(".fy-frame").forEach(function (f) { f.style.transform = ""; f.style.boxShadow = ""; });
    });
  }
  /* ---------- montage ---------- */
  function sceneHTML(extraClass) {
    return '<div class="fy-wall"></div>';
  }
  var mode = "examples";
  function setMode(m) {
    mode = m;
    var stage = document.querySelector(".fy-stage"), gal = document.querySelector(".product-information__media media-gallery");
    if (stage) stage.classList.toggle("on", m === "live");
    if (gal) gal.style.display = m === "live" && window.innerWidth >= 990 ? "none" : "";
    document.querySelectorAll(".fy-stage .fy-tabs button").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-v") === m)); });
    schedule();
  }
  function ensureStage() {
    var col = document.querySelector(".product-information__media");
    if (!col || !root() || col.querySelector(".fy-stage")) return;
    var st = document.createElement("div");
    st.className = "fy-stage fy-scene";
    st.innerHTML = '<div class="fy-bar"><div class="fy-tabs" role="group" aria-label="Affichage"><button type="button" data-v="live" aria-pressed="false">Mon affiche</button><button type="button" data-v="examples" aria-pressed="true">Photos d\'exemple</button></div>' +
      '<span class="fy-note"><span class="fy-dot" aria-hidden="true"></span>Aperçu en direct</span></div>' + sceneHTML() +
      '<p class="fy-note">Ce que vous voyez ici est calculé pour votre date et votre lieu : c\'est l\'affiche que vous recevrez. Cadre non inclus.</p>';
    col.insertBefore(st, col.firstChild);
    st.querySelectorAll(".fy-tabs button").forEach(function (b) { b.addEventListener("click", function () { setMode(b.getAttribute("data-v")); }); });
    if (mode === "live" || window.innerWidth >= 990) setMode("live");
    // onglet "Mon affiche" ajoute aussi dans la galerie
    ensureGalleryTab();
  }
  function ensureGalleryTab() {
    var col = document.querySelector(".product-information__media");
    if (!col || col.querySelector(".fy-galtab") || window.innerWidth < 990) return;
    var b = document.createElement("div");
    b.className = "fy-galtab";
    b.style.cssText = "display:flex;justify-content:flex-start;margin-bottom:12px";
    b.innerHTML = '<div class="fy-tabs" role="group" aria-label="Affichage"><button type="button" data-v="live" aria-pressed="false">Mon affiche</button><button type="button" data-v="examples" aria-pressed="true">Photos d\'exemple</button></div>';
    col.insertBefore(b, col.querySelector("media-gallery"));
    b.querySelectorAll("button").forEach(function (x) { x.addEventListener("click", function () { setMode(x.getAttribute("data-v")); }); });
    var upd = function () { b.style.display = mode === "live" ? "none" : "flex"; };
    upd(); new MutationObserver(upd).observe(document.querySelector(".fy-stage"), { attributes: true, attributeFilter: ["class"] });
  }
  var modal = null;
  function openModal() {
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "fy-modal fy-scene";
      modal.setAttribute("role", "dialog"); modal.setAttribute("aria-modal", "true"); modal.setAttribute("aria-label", "Aperçu de votre affiche");
      modal.innerHTML = '<button type="button" class="fy-x" aria-label="Fermer l\'aperçu">×</button>' + sceneHTML() +
        '<div class="fy-mrow"><div class="fy-tabs fy-mstyles" role="group" aria-label="Style"></div><button type="button" class="fy-cta">Ajouter au panier</button></div>';
      document.body.appendChild(modal);
      modal.querySelector(".fy-x").addEventListener("click", closeModal);
      modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("on")) closeModal(); });
      modal.querySelector(".fy-cta").addEventListener("click", function () {
        closeModal();
        var btn = document.querySelector('form[id^="BuyButtons-ProductForm"] [type=submit], .product-form-buttons [type=submit], button[name=add]');
        if (btn) btn.click();
      });
    }
    // styles disponibles = radios du selecteur de variantes
    var row = modal.querySelector(".fy-mstyles"); row.innerHTML = "";
    document.querySelectorAll('input[type=radio][name*="variant_picker"]').forEach(function (i) {
      if (!/nuit|crème|creme|minuit/i.test(i.value)) return;
      var b = document.createElement("button"); b.type = "button"; b.textContent = i.value;
      b.setAttribute("aria-pressed", String(i.checked));
      b.addEventListener("click", function () {
        var cur = document.querySelector('input[type=radio][name*="variant_picker"][value="' + i.value + '"]');
        if (cur) { cur.click(); }
        row.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        setTimeout(schedule, 50); setTimeout(schedule, 600);
      });
      row.appendChild(b);
    });
    row.style.display = row.children.length ? "" : "none";
    modal.classList.add("on"); document.documentElement.style.overflow = "hidden";
    schedule(); modal.querySelector(".fy-x").focus();
  }
  function closeModal() { if (modal) { modal.classList.remove("on"); document.documentElement.style.overflow = ""; } }

  /* ---------- lieu : suggestions ---------- */
  function wirePlace(input) {
    if (input.dataset.fyWired) return; input.dataset.fyWired = "1";
    var box = input.parentElement; box.style.position = "relative";
    var list = null, items = [], act = -1, timer = null;
    function hidden() { return document.querySelector('[data-fy="coords"]'); }
    function choose(it) {
      place = { label: it.label, lat: it.lat, lon: it.lon, tz: it.tz, typed: it.label };
      input.value = it.label; close(); schedule();
      var h = hidden(); if (h) h.value = it.lat.toFixed(4) + ", " + it.lon.toFixed(4) + " (" + it.tz + ")";
    }
    function close() { if (list) { list.remove(); list = null; } act = -1; input.setAttribute("aria-expanded", "false"); }
    function show() {
      close(); if (!items.length) return;
      list = document.createElement("div"); list.className = "fy-sug"; list.setAttribute("role", "listbox");
      items.forEach(function (it, i) {
        var b = document.createElement("button"); b.type = "button"; b.setAttribute("role", "option");
        b.innerHTML = "<span></span><small></small>"; b.firstChild.textContent = it.name; b.lastChild.textContent = it.detail;
        b.addEventListener("mousedown", function (e) { e.preventDefault(); choose(it); });
        list.appendChild(b);
      });
      var osm = document.createElement("div"); osm.className = "fy-osm"; osm.textContent = "Lieux : © OpenStreetMap"; list.appendChild(osm);
      box.appendChild(list); input.setAttribute("aria-expanded", "true");
    }
    input.setAttribute("autocomplete", "off");
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () {
        geocode(q).then(function (r) {
          if (input.value !== q) return;
          items = r; if (document.activeElement === input) show();
          if (r[0]) { // le premier resultat pilote l'apercu tant que rien n'est choisi
            place = { label: r[0].label, lat: r[0].lat, lon: r[0].lon, tz: r[0].tz, typed: q };
            var h = hidden(); if (h) h.value = r[0].lat.toFixed(4) + ", " + r[0].lon.toFixed(4) + " (" + r[0].tz + ")";
            schedule();
          }
        });
      }, 320);
    });
    input.addEventListener("keydown", function (e) {
      if (!list) return;
      var bs = list.querySelectorAll("button");
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault(); act = (act + (e.key === "ArrowDown" ? 1 : -1) + bs.length) % bs.length;
        bs.forEach(function (b, i) { b.classList.toggle("act", i === act); });
      } else if (e.key === "Enter" && act >= 0) { e.preventDefault(); choose(items[act]); }
      else if (e.key === "Escape") close();
    });
    input.addEventListener("blur", function () { setTimeout(close, 150); });
  }

  /* ---------- liaison des champs ---------- */
  function compose(r) {
    var dt = val(r, "date"), tm = val(r, "time"), out = r.querySelector('[data-fy="dateprop"]');
    if (!out) return;
    var md = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dt);
    if (!md) { out.value = ""; return; }
    var s = md[3] + "/" + md[2] + "/" + md[1];
    if (out.getAttribute("data-fy-time") === "1") {
      var mt = /^(\d{2}):(\d{2})/.exec(tm);
      s += mt ? " à " + mt[1] + "h" + mt[2] : " (heure inconnue : 21h00)";
    }
    out.value = s;
  }
  var saved = {}, savedFile = null, WIRED = new WeakSet();
  function build(r) {
    if (r.querySelector('[data-fy="names"]')) return;
    r.innerHTML = fieldsHTML(r.getAttribute("data-fy-type"), r.getAttribute("data-sid") || "x", r.getAttribute("data-fid") || "");
    Object.keys(saved).forEach(function (k) {
      var e = r.querySelector('[data-fy="' + k + '"]'); if (!e) return;
      if (e.type === "checkbox") e.checked = saved[k]; else e.value = saved[k];
    });
    if (!build.done) {
      build.done = true;
      try {
        var q = new URLSearchParams(location.search), set = function (k, v) { var e = r.querySelector('[data-fy="' + k + '"]'); if (e && v && !e.value) { e.value = v; saved[k] = v; } };
        if (/^\d{4}-\d{2}-\d{2}$/.test(q.get("date") || "")) set("date", q.get("date"));
        if (q.get("lieu")) { set("place", q.get("lieu")); set("city", (q.get("lieu") || "").split(",")[0]); }
        var la = parseFloat(q.get("lat")), lo = parseFloat(q.get("lon"));
        if (isFinite(la) && isFinite(lo)) {
          place = { label: q.get("lieu") || "", lat: la, lon: lo, tz: q.get("tz") || "Europe/Paris", typed: q.get("lieu") || "" };
          set("coords", la.toFixed(4) + ", " + lo.toFixed(4) + " (" + place.tz + ")");
        } else if (q.get("lieu")) {
          geocode(q.get("lieu")).then(function (res) { if (res[0]) { place = { label: res[0].label, lat: res[0].lat, lon: res[0].lon, tz: res[0].tz }; var h = r.querySelector('[data-fy="coords"]'); if (h) h.value = res[0].lat.toFixed(4) + ", " + res[0].lon.toFixed(4) + " (" + res[0].tz + ")"; schedule(); } });
        }
        if (q.get("date") || q.get("lieu")) { compose(r); if (window.innerWidth >= 990) setTimeout(function () { setMode("live"); }, 50); }
      } catch (e) {}
    }
    if (savedFile) { var p = r.querySelector('[data-fy="photo"]'); if (p) { try { var dt = new DataTransfer(); dt.items.add(savedFile); p.files = dt.files; var n = r.querySelector(".fy-photo-name"); if (n) n.textContent = savedFile.name; } catch (e) {} } }
  }
  function save(r) {
    r.querySelectorAll("[data-fy]").forEach(function (e) {
      var k = e.getAttribute("data-fy");
      if (e.type === "file") { if (e.files && e.files[0]) savedFile = e.files[0]; return; }
      saved[k] = e.type === "checkbox" ? e.checked : e.value;
    });
  }
  var mini = null, inlineVisible = true, fieldsActive = false;
  function ensureMini(r) {
    if (!mini) {
      mini = document.createElement("button");
      mini.type = "button"; mini.className = "fy-mini fy-scene";
      mini.setAttribute("aria-label", "Voir l'aperçu de mon affiche en grand");
      mini.innerHTML = '<div class="fy-wall"></div><span>Voir en grand</span>';
      mini.addEventListener("click", openModal);
      document.body.appendChild(mini);
    }
    var inl = r.querySelector(".fy-inline");
    if (inl && !inl.dataset.fyObs && "IntersectionObserver" in window) {
      inl.dataset.fyObs = "1";
      new IntersectionObserver(function (es) { inlineVisible = es[0].isIntersecting; updMini(); }).observe(inl);
      new IntersectionObserver(function (es) { fieldsActive = es[0].isIntersecting; updMini(); }, { rootMargin: "0px 0px -30% 0px" }).observe(r);
    }
  }
  function updMini() {
    if (!mini) return;
    var on = !inlineVisible && fieldsActive && window.innerWidth < 990;
    if (on !== mini.classList.contains("on")) { mini.classList.toggle("on", on); schedule(); }
  }
  function wire() {
    var r = root(); if (!r) return;
    build(r);
    ensureStage(); ensureGalleryTab();
    if (!WIRED.has(r)) {
      WIRED.add(r);
      r.addEventListener("input", function (e) {
        compose(r); save(r);
        if (mode !== "live" && window.innerWidth >= 990) setMode("live");
        schedule();
      });
      r.addEventListener("change", function () { compose(r); save(r); schedule(); });
      r.addEventListener("focusin", function () { if (mode !== "live" && window.innerWidth >= 990) setMode("live"); });
    }
    ensureMini(r);
    r.querySelectorAll('[data-fy="place"]').forEach(wirePlace);
    r.querySelectorAll(".fy-open").forEach(function (b) {
      if (b.dataset.fyWired) return; b.dataset.fyWired = "1";
      b.addEventListener("click", openModal);
    });
    r.querySelectorAll('[data-fy="photo"]').forEach(function (inp) {
      if (inp.dataset.fyWired) return; inp.dataset.fyWired = "1";
      inp.addEventListener("change", function () {
        var f = inp.files && inp.files[0]; if (!f) return;
        var url = URL.createObjectURL(f), im = new Image();
        im.onload = function () { photoImg = im; schedule(); var lab = r.querySelector(".fy-photo-name"); if (lab) lab.textContent = f.name; };
        im.src = url;
        var later = r.querySelector('[data-fy="photolater"]'); if (later) { later.checked = false; later.required = false; }
        inp.setCustomValidity("");
      });
    });
    var later = r.querySelector('[data-fy="photolater"]'), ph = r.querySelector('[data-fy="photo"]');
    if (later && ph && !later.dataset.fyWired) {
      later.dataset.fyWired = "1";
      var chk = function () { ph.setCustomValidity(ph.files.length || later.checked ? "" : "Ajoutez votre photo, ou cochez « Je l'enverrai par e-mail »."); };
      later.addEventListener("change", chk); ph.addEventListener("change", chk); chk();
    }
    schedule();
  }
  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type=radio][name*="variant_picker"]')) { setTimeout(schedule, 30); setTimeout(wire, 400); setTimeout(schedule, 700); }
  }, true);
  window.addEventListener("resize", function () { if (window.innerWidth < 990) { var g = document.querySelector(".product-information__media media-gallery"); if (g) g.style.display = ""; } else if (mode === "live") setMode("live"); schedule(); });
  fontsReady.then(function () { schedule(); });
  if (cfg.moonTex) moonTex();
  function boot() { wire(); setInterval(function () { wire(); if (mode === "live") { var g = document.querySelector(".product-information__media media-gallery"); if (g && g.style.display !== "none" && window.innerWidth >= 990) setMode("live"); } }, 800); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();

  window.FYRender = { drawSky: drawSky, drawFilm: drawFilm, drawMoon: drawMoon, moonState: moonState, localToUtc: localToUtc, lst: lst, proj: proj, sky: sky };
})();
